// @flow
import { wipActionTypes as ActionType, wipTypes as Types } from '../constants';

const initialState = {
  orchestrationName: 'Untitled Campaign'
};

export default function WIPReducer(
  state: Types.InitialState = initialState,
  action: Types.Action
) {
  switch (action.type) {
    case ActionType.CHOOSE_ORCHESTRATION_NAME: {
      const { orchestrationName } = action.payload;
      return {
        ...state,
        orchestrationName
      };
    }
    case ActionType.CHOOSE_APP_GROUP: {
      const { appGroup } = action.payload;
      return {
        ...state,
        appGroup
      };
    }
    case ActionType.CHOOSE_ENTRY_EVENT: {
      const { entryEvent } = action.payload;
      return {
        ...state,
        entryEvent
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/wip.js